
export default function advertiserFactory() {
  const BSCS = window.adacado.bscs
  const myToken = BSCS.getToken()
  return {
    create(advertiser, annotation) {
      return BSCS.doRequest({
        token: myToken,
        annotation,
        requestMethod: 'POST',
        requestPath: '/advertiser/v3/create',
        requestParameters: [],
        payload: converttoJson(advertiser)
      })
    },
    get(advertiserID, callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/advertiser/v3/get/:adi',
        requestParameters: [
          { key: 'adi', value: advertiserID }
        ],
        callback: (advertiser, token, annotation) => {
          if (!advertiser.Properties) {
            advertiser.Properties = {}
          } else if (typeof advertiser.Properties === 'string') {
            advertiser.Properties = JSON.parse(advertiser.Properties)
          }
          callback(advertiser, token===myToken, annotation)
        }
      })
    },
    getAll(callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/advertiser/v3/getall',
        requestParameters: [],
        callback: (advertisers, token, annotation) => {
          if (!advertisers) {
            advertisers = []
          } else {
            for (let adv of advertisers) {
              adv.Properties = typeof adv.Properties == 'string' ? JSON.parse(adv.Properties) : {}
            }
          }
          callback(advertisers, token===myToken, annotation)
        }
      })
    },
    getVertical(advertiserID, callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/advertiser/v3/vertical/:adi',
        requestParameters: [
          { key: 'adi', value: advertiserID }
        ],
        callback: (vertical, token, annotation) => {
          callback(vertical, token===myToken, annotation)
        }
      })
    },
    update(advertiser, annotation) {
      return BSCS.doRequest({
        token: myToken,
        annotation,
        requestMethod: 'PUT',
        requestPath: '/advertiser/v3/update',
        requestParameters: [],
        payload: converttoJson(advertiser)
      })
    },
    saveScraperConfig(advertiserID, scraperConfig, annotation) {
      return BSCS.doRequest({
        token: myToken,
        annotation,
        requestMethod: 'PUT',
        requestPath: '/advertiser/v3/advertiser/:adi/scraperconfig/save',
        requestParameters: [
          { key: 'adi', value: advertiserID }
        ],
        payload: converttoJson(scraperConfig)
      })
    },
    updateShopifyAccessToken(advertiserID, accessToken, shop, annotation) {
      const token = {
        "token": accessToken,
        "shop": shop,
      }
      return BSCS.doRequest({
        token: myToken,
        annotation,
        requestMethod: 'PUT',
        requestPath: '/advertiser/v3/updateshopifytoken/:adi',
        requestParameters: [
          { key: 'adi', value: advertiserID }
        ],
        payload: converttoJson(token)
      })
    },
    checkShopifyShopUsed(shop = '', annotation) {
      return BSCS.doRequest({
        token: myToken,
        annotation,
        requestMethod: 'GET',
        requestPath: '/advertiser/v3/checkshopifyshopused/:shop',
        requestParameters: [
          { key: 'shop', value: shop }
        ],
      })
    },
    isPixelPlaced(url, callback) {
      return BSCS.doRequest({
        token: myToken,
        requestMethod: 'GET',
        requestPath: '/advertiser/v3/ispixelplaced/:encodedurl',
        requestParameters: [
          { key: 'encodedurl', value: encodeURIComponent(url) }
        ],
        callback: (isPixelPlaced, token, annotation) => {
          callback(isPixelPlaced, token===myToken, annotation)
        }
      })
    }
  }
}

function converttoJson(obj) {
  const newObj = JSON.parse(JSON.stringify(obj));
  if (newObj.Properties && typeof newObj.Properties === 'object') {
    newObj.Properties = JSON.stringify(newObj.Properties);
  }
  return JSON.stringify(newObj);
}